import React from 'react';
export function EDMSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10" data-id="element-2204">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-6" data-id="element-2205">
        Electric Discharge Machining (EDM)
      </h2>
      <ul className="space-y-3 list-disc list-inside mb-8" data-id="element-2206">
        <li data-id="element-2207">
          <a href="/WhatIsEDM.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2208">
            What is EDM?
          </a>
        </li>
        <li data-id="element-2209">
          <a href="/WhatIsEDM.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2210">
            History of EDM
          </a>
        </li>
      </ul>

      <h3 className="text-xl font-bold text-[#1967a5] mb-4" data-id="element-2211">Wire EDM</h3>
      <ul className="space-y-3 list-disc list-inside mb-8" data-id="element-2212">
        <li data-id="element-2213">
          <a href="/WireTypesHowToChooseWire.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2214">
            Wire Types - How to Choose Wire
          </a>
        </li>
        <li data-id="element-2215">
          <a href="/ImprovingWireEDMProductivity.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2216">
            Tips for Improving Wire EDM Productivity
          </a>
        </li>
        <li data-id="element-2217">
          <a href="https://www.peakedm.com/uploaded/files/AgieCharmilles/What%20Makes%20AgieCharmilles%20EDM%20Different%20-%20Titans%20of%20CNC.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg" data-id="element-2218">
            What makes AgieCharmilles EDM different, and why are the Titans of
            CNC are calling the CUT P PRO the MOST ADVANCED Wire EDM in the
            world?
          </a>
        </li>
      </ul>

      <h3 className="text-xl font-bold text-[#1967a5] mb-4" data-id="element-2219">Die-Sinking EDM</h3>
      <ul className="space-y-3 list-disc list-inside" data-id="element-2220">
        <li data-id="element-2221">
          <a href="https://www.peakedm.com/58.html?m8:post=how-to-edm-steel-and-copper-alloy-simultaneously" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg" data-id="element-2222">
            How to EDM Steel &amp; Copper Alloy Simultaneously
          </a>
        </li>
        <li data-id="element-2223">
          <a href="https://www.peakedm.com/uploaded/files/EDM%20Copper%20vs%20Graphite%20Electrodes.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg" data-id="element-2224">
            EDM Copper vs Graphite Electrodes
          </a>
        </li>
      </ul>
    </div>;
}